import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-plan-upgrade',
  templateUrl: './modal-plan-upgrade.component.html',
  styleUrls: ['./modal-plan-upgrade.component.scss']
})
export class ModalPlanUpgradeComponent implements OnInit {

  constructor(
    public bsModalRef: BsModalRef
  ) { }

  ngOnInit(): void {
  }

}
